import {Outlet} from 'react-router-dom';
import {LoadingOverlay} from "components/core/loading-overlay";
import {useGetAccount} from "features/profile/hooks/use-account";
import {useEffect} from "react";
import {useCommonStore} from "state/store/common/useCommonStore";

export default function UserHolder() {
  const setUser = useCommonStore((state) => (
    state.setUser));
  const user = useCommonStore((state) => (
    state.user));
  
  const {data, isLoading, isFetching} = useGetAccount({enabled: !user});
  
  useEffect(() => {
    if (data) {
      setUser(data);
    }
  }, [data, setUser]);
  
  if (isLoading || isFetching) {
    return <LoadingOverlay/>;
  }
  
  return (
    <Outlet/>
  );
}
